import { staticColors } from "./colors.static";

export { getContrastTextColor } from "./colors.static";

/**
 * Hub color tokens. Black stage, white chrome (see `colors.static.ts`).
 */
export const colors = staticColors;
